export default "__VITE_ASSET__BYTfCusN__"